import { formatExploreBookingBody } from "@/lib/explore-notifications";
import {
  ensureExplorePushReady,
  saveExploreDeviceForBooking,
  sendExploreCustomerPush,
} from "@/lib/explore-push";
import { isExploreAppVariant } from "@/lib/platform";

export type ExploreBookingNotifyInput = {
  businessName: string;
  businessSlug: string;
  serviceLabel: string;
  startDatetime: Date | string;
  pendingPayment?: boolean;
  confirmationCode?: string | null;
};

/**
 * OneSignal push to the Explore customer (Buukd Explore app).
 * Business owners still receive sendOwnerPush separately.
 */
export async function notifyExploreCustomerBooking(
  input: ExploreBookingNotifyInput
): Promise<boolean> {
  if (!isExploreAppVariant()) return false;

  const body = formatExploreBookingBody({
    businessName: input.businessName,
    serviceLabel: input.serviceLabel,
    startDatetime: input.startDatetime,
  });

  const pending = Boolean(input.pendingPayment);
  const title = pending ? "Booking pending" : "Booking confirmed";

  const code = String(input.confirmationCode || "").trim();
  const url = `/book/${input.businessSlug}/manage${code ? `?code=${encodeURIComponent(code)}` : ""}`;

  if (code) {
    await saveExploreDeviceForBooking(code);
  }

  await ensureExplorePushReady();
  return sendExploreCustomerPush({ title, body, url });
}
